import ComponentManager from "../../componentFramework";
import jQuery from "jquery";
import EventListenerManager from "../EventListenerManager";

declare function require(moduleName: string): any;
const datetimepicker = require("jquery-datetimepicker"); // This is used indirectly, so it cannot be removed

declare global {
	interface JQuery {
		datetimepicker: (arg: any) => any;
	}
	interface JQueryStatic {
		datetimepicker: any;
	}
}

/**
 * This uses: https://xdsoft.net/jqplugins/datetimepicker/
 */
@ComponentManager.register()
export default class DateTimePicker {
	public static componentStyleClass = "dateTimePicker";
	private static configs: { [key:string]: {format:string, datepicker: boolean, timepicker: boolean } } = {
		Date: {
			format: "Y-m-d",
			datepicker: true,
			timepicker: false
		},
		DateTime: {
			format: "Y-m-d H:i",
			datepicker: true,
			timepicker: true
		},
		// TODO (Michael): There is no format for milliseconds with "jquery-datetimepicker". This is used in one spot too.
		DateTimeMs: {
			format: "Y-m-d H:i",
			datepicker: true,
			timepicker: true
		},
		Time : {
			format: "H:i",
			datepicker: false,
			timepicker: true
		}
	};

	private readonly eventListenerManager = new EventListenerManager();

	constructor(private readonly rootElement: HTMLElement) {
		this.eventListenerManager.manage(rootElement).addEventListener("click", () => {
			this.createAndOpenJQueryPicker();
		});
	}

	private onPickerClose = () => {
		this.destroyJQueryPicker();
		this.rootElement.dispatchEvent(new Event("change", {bubbles: true, cancelable: false}));
	}
	
	private createAndOpenJQueryPicker() {
		const options: any = {
			open: true,
			onClose: this.onPickerClose,
		};

		let config: any;
		let configName = this.rootElement.getAttribute("data-datetimepicker-config");
		if (configName !== null) {
			config = DateTimePicker.configs[configName];
		}
		if (config === undefined) {
			config = DateTimePicker.configs.DateTime;
		}

		options.format = config.format;
		options.datepicker = config.datepicker;
		options.timepicker = config.timepicker;

		const jq = jQuery(this.rootElement);
		jq.datetimepicker(options).trigger("open.xdsoft");
	}
	
	private destroyJQueryPicker() {
		// This will remove the elements added by datetimepicker
		jQuery(this.rootElement).datetimepicker("destroy");
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		this.eventListenerManager.removeListeners();
		this.destroyJQueryPicker();
	}
}

jQuery.datetimepicker.setLocale("en");
